/**
 * Headers for CRR API calls. OIDC (Keycloak) is obtained on the backend when
 * this Microsoft Graph token is sent — secrets stay server-side.
 */
export async function getCrrAuthHeaders(msalInstance, account, scopes, extraHeaders = {}) {
	if (!account) {
		throw new Error('Utilisateur non connecté');
	}
	const tokenResponse = await msalInstance.acquireTokenSilent({
		scopes,
		account,
	});
	return {
		'X-Microsoft-Access-Token': tokenResponse.accessToken,
		...extraHeaders,
	};
}
